<template>
  <tr>
    <td>{{ user.name }}</td>
    <td>{{ user.initials }}</td>
    <td>
      <v-text-field v-model="sync_email" :disabled="!user.isNewlySelected">
        <v-icon v-if="!user.isNewlySelected" slot="append-outer" class="lock-button" color="black" @click="unlockEmailEdit">edit</v-icon>
      </v-text-field>
    </td>
    <td><v-checkbox v-model="sync_isAdmin"></v-checkbox></td>
    <td v-if="shouldDisplayValidatedColumn">
      <div v-if="user.isValidated">
        <v-icon>done</v-icon>
      </div>
      <div v-if="!user.isValidated">
        <v-btn color="#FF9E15" :loading="resendingLink" :disabled="user.isNewlySelected" @click="sendLink(user.initials)">
          Resend Link
        </v-btn>
      </div>
    </td>
    <td><v-icon @click="emitRemoveUser()">delete</v-icon></td>
  </tr>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'UserSelectionRow',
  props: {
    user: {
      type: Object, required: true
    },
    shouldDisplayValidatedColumn: {
      type: Boolean, required: true
    }
  },
  data () {
    return {
      resendingLink: false
    };
  },
  computed: {
    sync_email: {
      get () {
        return this.user.email;
      },
      set (val) {
        this.$emit('update:email', val);
      }
    },
    sync_isAdmin: {
      get () {
        return this.user.isAdmin;
      },
      set (val) {
        this.$emit('update:isAdmin', val);
        this.$emit('editEmailEvent', val);
      }
    },
    sync_isNewlySelected: {
      get () {
        return this.user.isNewlySelected;
      },
      set (val) {
        this.$emit('update:isNewlySelected', val);
      }
    }
  },
  methods: {
    ...mapActions(['setError']),
    async sendLink () {
      this.resendingLink = true;

      var resendLinkResp = await this.$api.resendLink(this.user.email);
      if (resendLinkResp.code !== 0) {
        this.setError({ errorMessage: `Error - Unable to resend confirmation link. Message: ${resendLinkResp.message}` });
      }

      this.resendingLink = false;
    },
    emitRemoveUser () {
      this.$emit('removeUserEvent', this.user.initials);
    },
    unlockEmailEdit () {
      this.sync_isNewlySelected = true;
    }
  }
};

</script>

<style>
    .lock-button {
        pointer-events: auto;
    }
</style>
